// ============================================================================
// Provider directory API (read-only). Backend: backend/providers/urls.py,
// mounted by core.urls at /api/providers/.
//
//   GET /api/providers/organizations/         (list; ?is_active=true)
//   GET /api/providers/facilities/?provider=  (list facilities of a provider)
//
// Providers/facilities are created + edited in Django admin (PRs 1-5); this
// client is read-only, used to populate the campaign "conducting provider /
// facility" dropdowns.
// ============================================================================

import { api } from './client.js'
import { unwrapList } from '../utils/format.js'

export async function listProviderOrganizations(params = {}) {
  const { data } = await api.get('/api/providers/organizations/', {
    params: { page_size: 200, is_active: true, ...params },
  })
  return unwrapList(data)
}

export async function listProviderFacilities(params = {}) {
  const { data } = await api.get('/api/providers/facilities/', {
    params: { page_size: 200, is_active: true, ...params },
  })
  return unwrapList(data)
}
